module.exports = __webpack_public_path__ + "static/media/DialogueWithTime.07c452ff.mp4";